import { Style } from 'inlines'

export type Typography =
  | 'title-regular'
  | 'title-medium'
  | 'title-bold'
  | 'heading-regular'
  | 'heading-medium'
  | 'heading-bold'
  | 'display-regular'
  | 'display-medium'
  | 'display-bold'
  | 'display-mono'
  | 'subheading-regular'
  | 'subheading-medium'
  | 'subheading-bold'
  | 'subtext-regular'
  | 'subtext-medium'
  | 'subtext-bold'
  | 'subtext-mono'

const GEIST_REGULAR_FONT =
  '"Geist","Inter",-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif'
const GEIST_MONOSPACE_FONT =
  '"Geist Mono","Roboto Mono",Menlo,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New,monospace'

export const TEXT_VARIANT_STYLES: Record<Typography, Style> = Object.freeze({
  'title-regular': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '28px',
    fontWeight: 400,
    lineHeight: '30.8px',
    letterSpacing: '-0.5px',
  },
  'title-medium': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '28px',
    fontWeight: 600,
    lineHeight: '30.8px',
    letterSpacing: '-0.5px',
  },
  'title-bold': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '28px',
    fontWeight: 800,
    lineHeight: '30.8px',
    letterSpacing: '-0.5px',
  },
  'heading-regular': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '22px',
    fontWeight: 300,
    lineHeight: '24.2px',
    letterSpacing: '0px',
  },
  'heading-medium': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: '24.2px',
    letterSpacing: '0px',
  },
  'heading-bold': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '22px',
    fontWeight: 800,
    lineHeight: '24.2px',
    letterSpacing: '-0.4px',
  },
  'subheading-regular': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '18px',
    fontWeight: 300,
    lineHeight: '22.5px',
    letterSpacing: '0.2px',
  },
  'subheading-medium': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '22.5px',
    letterSpacing: '0px',
  },
  'subheading-bold': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '22.5px',
    letterSpacing: '-0.4px',
  },
  'display-mono': {
    fontFamily: GEIST_MONOSPACE_FONT,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    letterSpacing: '-0.4px',
  },
  'display-regular': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: '0.1px',
  },
  'display-medium': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    letterSpacing: '0px',
  },
  'display-bold': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '21px',
    letterSpacing: '-0.1px',
  },
  'subtext-mono': {
    fontFamily: GEIST_MONOSPACE_FONT,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16.5px',
    letterSpacing: '-0.2px',
  },
  'subtext-regular': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16.5px',
    letterSpacing: '0.1px',
  },
  'subtext-medium': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16.5px',
    letterSpacing: '0px',
  },
  'subtext-bold': {
    fontFamily: GEIST_REGULAR_FONT,
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '16.5px',
    letterSpacing: '-0.1px',
  },
})
